import IPlugin from "./plugin";
import VueRouter from "vue-router";
import router from "../routers";

export default class RouterPlugin extends IPlugin {
    setup(Vue, config) {
        Vue.use(VueRouter);
        config.router = new VueRouter(router);
        return super.setup(Vue, config);
    }
}